
import { Component, OnInit } from '@angular/core';
import { LookupService } from 'src/app/Services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { SalService } from 'src/app/Services/sal/sal.service';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentviewmodelComponent } from '../paymentviewmodel/paymentviewmodel.component';

@Component({
  selector: 'app-admin-invoice-receipt',
  templateUrl: './admin-invoice-receipt.component.html',
  styleUrls: ['./admin-invoice-receipt.component.css']
})
export class AdminInvoiceReceiptComponent implements OnInit {

  Submitted: boolean = false;
  Action: any = "Add";
  constructor(private modalService: NgbModal,private router: Router, private salservice: SalService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) {


  }

  SearchModel = {
    SchoolID: 0,
    BranchID: 0,
    ToDate: '',
    FromDate: '',
    ReceiptNo: '',
    CurrencyCode: '--- Select  ---',
    PaymentStatusID: 0,
    CurrentIndex: 0,
    PageSize: 20
  };

  ClearSearch() {
    this.SearchModel.BranchID = 0;
    this.SearchModel.SchoolID = 0;
    this.SearchModel.PaymentStatusID = 0;
    this.SearchModel.ReceiptNo = '';
    this.SearchModel.FromDate = '';
    this.SearchModel.ToDate = '';
    this.SearchModel.CurrencyCode = '--- Select  ---';
    this.ReceiptList = [];
  }

  ReceiptList = [];
  GetAllPayment() {
    this.SearchModel.CurrentIndex = this.currentPage;
    this.SearchModel.PageSize = this.pageSize;
    this.spinnerService.show();
    this.salservice.GetAdminAllPayment(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.ReceiptList = response.ReceiptList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(response);
      this.recordCount = 0;
      if (response.ReceiptList != null && response.ReceiptList.length > 0) {
        this.recordCount = response.ReceiptList[0].RecordCount;
      }
      this.numberOfPages();
    });
  };


  
  // View Invoice
PaymentDetails: any;
ViewPayment(item) {

  this.PaymentDetails = item;

  const modalRef = this.modalService.open(PaymentviewmodelComponent, { size: 'lg' });
  modalRef.componentInstance.PaymentDetails = this.PaymentDetails;

  modalRef.result.then((result) => {
    if (result) {
      console.log(result);
    }
  });

}
PrintInvoice(item) {
 
  window.localStorage.setItem("PaymentDetails", JSON.stringify(item));
  var url ="printinvoice";
  this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
};
  ngOnInit() {
    window.localStorage.removeItem("PaymentDetails");
    this.GetAllSchool();
    this.GetSchoolBranch();
    this.GetAllCurrency();
    this.GetPaymentStatus();
    this.GetAllPayment();
  }

  // Lookup 

  SchoolList: any;
  GetAllSchool() {   
    this.lookupservice.GetLookupsList('GroupSchool','').subscribe((data: any) => {
      this.SchoolList = data.LookupItems;

    });
  };
  CurrencyList: any;
  GetAllCurrency() {   
    this.lookupservice.GetLookupsList('SALCurrency','').subscribe((data: any) => {
      this.CurrencyList = data.LookupItems;

    });
  };

  BranchList: any;
  GetSchoolBranch() {  
    var item = {
      'SchoolID': this.SearchModel.SchoolID
    }
    this.lookupservice.GetLookupsList('TicketBranchSchool',JSON.stringify(item)).subscribe((data: any) => {
      this.BranchList = data.LookupItems;

    });
  };

  PaymentStatusList: any;
  GetPaymentStatus() {   
    this.lookupservice.GetLookupsList('PaymentStatus','').subscribe((data: any) => {
      this.PaymentStatusList = data.LookupItems;

    });
  };

  // Paging

  currentPage = 1;
  pageSize = 20;
  recordCount = 0;
  totalPages = 0;
  numberOfPages() {
    this.totalPages = Math.ceil(this.recordCount / this.pageSize);
  }

  nextPage() {
    this.currentPage = this.currentPage + 1;
  }

  pageSizes() {
    this.currentPage = 1;
    this.recordCount = 0;
    this.totalPages = 0;
  }


}


